import React, { Component } from "react";
import {
  Widget,
  addResponseMessage,
  addUserMessage,
  dropMessages,
  toggleWidget,
} from "react-chat-widget";

//import axios from 'axios'
import { v4 as uuidv4 } from 'uuid';

import "react-chat-widget/lib/styles.css";
import "./index.css";

import { APP_NAME } from "../../constants";

import { HandleSetRealTimeDB } from 'DBServices/realTimeDBService';
import sound from "./assets/notificationTone.mp3";

const userIdentity = uuidv4();

      addResponseMessage(`Welcome to ${APP_NAME}!`);
addResponseMessage("Are you looking for anything in particular?");

class Client extends Component {
  state = {
    ip: userIdentity
  }

  /* getData = async () => {
    const res = await axios.get('https://geolocation-db.com/json/');
    if (res && res.data && res.data.IPv4) {
      this.setState({...this.state, ip: res.data.IPv4.toString().replaceAll('.', '')});
    } 
  } */
  componentDidMount() {
    
    
    // check for uid, if exist then get auth token, login, create message listener and fetch previous messages
    const starCountRef = HandleSetRealTimeDB.ref(HandleSetRealTimeDB.database, `messages/${this.state.ip}`);
    HandleSetRealTimeDB.onValue(starCountRef, (snapshot) => {
      dropMessages();
addResponseMessage(`Welcome to ${APP_NAME}!`);
      addResponseMessage("Are you looking for anything in particular?");      
      snapshot.forEach((childSnapshot) => {
        //const childKey = childSnapshot.key;
        const childData = childSnapshot.val();
        //messages = [...messages, childData];
        if (childData.sender) {
          childData.message && addUserMessage(childData.message.toString());
        } else {
          childData.message && addResponseMessage(childData.message.toString());        }
        // ...
      });
      new Audio(sound).play()
    });
  }  

  handleNewUserMessage = (newMessage) => {
    console.log(`New message incoming! ${newMessage}`);
    //let uid = getUser.auth.currentUser.uid;

    let textMessage = {
      sender: this.state.ip,
      message: newMessage,
      new: 'new'
    };

    HandleSetRealTimeDB.push(HandleSetRealTimeDB.ref(HandleSetRealTimeDB.database, 'messages/' + this.state.ip), textMessage)
    .then(() => {
      // Data saved successfully!
    })
    .catch((error) => {
      // The write failed...
      alert("Unable to send message, please resend.");
    });
  };

  componentWillUnmount() {
    dropMessages();
  }
/**
 * 
 * var hasClass = document.getElementsByClassName('hide-sm')
if(hasClass.length === 0){
toggleWidget()
}
*/
  render() {
    return (
      <div className="body-customer-support">
        <div className="App">
          <Widget
            handleNewUserMessage={this.handleNewUserMessage}
            title="Customer Support Live Chat"
            subtitle="Ready to help you. Need a custom order? Send us a direct message here!"
          />
        </div>
      </div>
    );
  }
}

export default Client;
